interface GlobalContextType {
  referer: null | string;
}

class GlobalContext {
  private readonly context: GlobalContextType;
  constructor() {
    this.context = {
      referer: null,
    };
  }
  setContext<K extends keyof GlobalContextType>(
    key: K,
    value: GlobalContextType[K],
  ) {
    this.context[key] = value;
  }

  getContext(key: keyof GlobalContextType) {
    return this.context[key];
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new GlobalContext();
